import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "./Tickets.css";
import { CustomDataGrid } from "../../../../Assets/Elements";
import { AuthContext } from "../../../../Context/AuthContextProvider";
import PropTypes from "prop-types";

const statusColors = {
  open: "bg-green-500",
  assigned: "bg-blue-500",
  inprogress: "bg-yellow-500",
  pending: "bg-orange-500",
  closed: "bg-gray-500",
  reopened: "bg-purple-500",
};

function TicketsList({ tickets }) {
  TicketsList.propTypes = {
    tickets: PropTypes.any,
  };

  const { formatDate } = useContext(AuthContext);

 const baseCellClass =
  "flex items-center h-full px-3 py-2 text-[14px] font-semibold";

const columns = [
  {
    field: "ticketId",
    headerName: "Ticket ID",
    width: 160,
    headerClassName: "bg-[#b99653] text-white font-bold text-[15px] px-3",
    renderCell: (params) => (
      <p className={`${baseCellClass} text-gray-700`}>
        {params.row.ticketId || "Unavailable"}
      </p>
    ),
  },
  {
    field: "createdOn",
    headerName: "Created",
    width: 180,
    headerClassName: "bg-[#b99653] text-white font-bold text-[15px] px-3",
    renderCell: (params) => (
      <p className={`${baseCellClass} text-black`}>
        {params.row.createdOn ? formatDate(params.row.createdOn) : "Unavailable"}
      </p>
    ),
  },
  {
    field: "latestUpdated",
    headerName: "Last Update",
    width: 180,
    headerClassName: "bg-[#b99653] text-white font-bold text-[15px] px-3",
    renderCell: (params) => (
      <p className={`${baseCellClass} text-gray-500`}>
        {params.row.latestUpdated
          ? formatDate(params.row.latestUpdated)
          : "Unavailable"}
      </p>
    ),
  },
  {
    field: "title",
    headerName: "Title",
    width: 180,
    headerClassName: "bg-[#b99653] text-white font-bold text-[15px] px-3",
    renderCell: (params) => (
      <p className={`${baseCellClass} text-gray-900`}>
        {params.row.title || "Unavailable"}
      </p>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    width: 130,
    headerClassName: "bg-[#b99653] text-white font-bold text-[15px] px-3",
  renderCell: (params) => (
  <div className="flex items-center h-full">
    <span
      className={`
        text-white text-xs font-semibold rounded-full
        px-3 py-[2px]      /* FIX: reduce height */
        capitalize
        ${statusColors[params.row.status] || "bg-gray-500"}
      `}
      style={{
        lineHeight: "1rem", /* FIX: keeps pill height small */
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: "22px"      /* FIX: exact stable pill height */
      }}
    >
      {params.row.status}
    </span>
  </div>
)

  },
  {
    field: "owner",
    headerName: "Handler",
    width: 160,
    headerClassName: "bg-[#b99653] text-white font-bold text-[15px] px-3",
    renderCell: (params) => (
      <p className={`${baseCellClass} text-gray-900`}>
        {params.row.owner || "Unassigned"}
      </p>
    ),
  },
  {
    field: "details",
    headerName: "Action",
    width: 150,
    headerClassName: "bg-[#b99653] text-white font-bold text-[15px] px-3",
    renderCell: (params) => (
      <div className="flex items-center h-full">
        <Link to={`/dashboard/SingleTicket/${params.row.ticketId}`}>
          <button
            className="
              bg-[#b99653] hover:bg-[#9d7a3d]
              text-white font-bold text-sm
              px-4 py-2 rounded-xl
              transition-all
            "
          >
            View
          </button>
        </Link>
      </div>
    ),
  },
];


  const rows = tickets.map((ticket) => ({
    id: ticket._id,
    ticketId: ticket._id,
    title: ticket.title,
    description: ticket.description,
    status: ticket.status,
    owner: ticket.assignmentHistory[0]?.assignedTo.AdminName,
    createdOn: ticket.createdDate,
    latestUpdated: ticket.lastUpdatedDate,
    ...ticket,
  }));

  return (
    <div className="tickets-list-data-grid bg-white rounded-2xl shadow-xl p-4 border border-gray-200">
      <CustomDataGrid rows={rows} columns={columns} />
    </div>
  );
}

export default TicketsList;
